import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, catchError, map, of, retry, switchMap, takeUntil, tap } from 'rxjs';
import { ErrorHandlerService } from 'src/app/api/error-handler.service';
import { ProductService } from 'src/app/api/routes/product.service';
import { BaseComponent } from 'src/app/components/base.component';
import { AUTO_DRAW_ENUM } from 'src/app/core/enum';
import { ProductModels } from 'src/app/core/models';
import { FileService } from 'src/app/shared/file.service';
import { CloseAction, OpenAction, SpinnerState } from 'src/app/store/spinner';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss']
})
export class ProductDetailComponent extends BaseComponent implements OnInit {
	public environment = environment;

	// 當前產品id
	public productId = 0;

	// 當前產品
	public product: ProductModels.Product | undefined;

	// 其他同種類產品list
	public productList: ProductModels.Product[] = [];

	// 將產品應用作換行處理
	public productApplication: string[] = [];

	public TIM_TYPE = AUTO_DRAW_ENUM.TIM_TYPE;

	constructor(
		private productServ: ProductService,
		private cd: ChangeDetectorRef,
		private spinnerState: Store<SpinnerState>,
		private errServ: ErrorHandlerService,
		private http: HttpClient,
		private fileServ: FileService,
		private route: ActivatedRoute,
		private translate: TranslateService
	) { super(); }

	ngOnInit(): void {
		console.log('product-detail')
		// 當路徑變動則重新取得新資料
		this.route.params.pipe(
			tap(data => {
				this.productId = data['id'];
				this.initData();
				this.cd.markForCheck()
			}),
		).subscribe()
	}

	/**
	 * API取得初始資料
	 */
	public initData(){
		// 取得該產品及相同類別產品
		this.fetchProduct().pipe(
			tap(data => {
				this.product = data
				this.product.image_path = environment.settings.imageUrl + this.product.image_path;
				console.log(this.product.image_path)
				this.product.feature_from_path = environment.settings.imageUrl + this.product.feature_from_path;
				// 進行換行設置
				this.productApplication = this.product.application.split(/\n/g)
				// this.product.image = this.base64ToUrl(<string>this.product.image)
				// this.product.feature_from = this.base64ToUrl(<string>this.product.feature_from)
				
				this.spinnerState.dispatch(new CloseAction());
				this.cd.markForCheck()
			}),
			switchMap(data => this.fetchProductList()),
			tap(data => {
				this.productList = data.filter(product => {
					// product.image = this.base64ToUrl(<string>product.image);
					product.image_path = environment.settings.imageUrl + product.image_path;
					console.log(product.image_path)
					return product.id !== this.product?.id
				})
				
				this.spinnerState.dispatch(new CloseAction());
				this.cd.markForCheck()
			})
		).subscribe()
	}

	/**
	 * API查詢產品詳情
	 * @returns 回傳Product Model的Observable
	 */
	public fetchProduct(): Observable<ProductModels.Product>{
		let param = {
			product_id: this.productId,
			is_return_report_file: 0
		}
		this.spinnerState.dispatch(new OpenAction('Loading...'));
		const $detail = this.productServ.fetchDetail(param).pipe(
			takeUntil(this.unsubscribe$),
			catchError(err => {
				this.spinnerState.dispatch(new CloseAction());
				this.errServ.httpErrorHandle(err);
				return of()
			}),
			map(res => res.Data),
		)

		return $detail
	}


	/**
	 * API 查詢產品List，不含產品特性
	 * @returns 回傳 Product Model 陣列 Observable
	 */
	public fetchProductList(): Observable<ProductModels.Product[]>{
		let param = {
			type: this.product?.type,
			language_type: 1,  // 語言類型
			is_return_feature: 0  // 是否回傳特型(0 否 1 是)
		}
		this.spinnerState.dispatch(new OpenAction('Loading...'));
		const $productList = this.productServ.fetchList(param).pipe(
			takeUntil(this.unsubscribe$),
			catchError(err => {
				this.spinnerState.dispatch(new CloseAction());
				this.errServ.httpErrorHandle(err);
				return of()
			}),
			map(res => res.Data),
		)

		return $productList
	}


	/**
	 * 將圖片base64轉為可顯示url
	 * @param base64 檔案base64格式
	 * @returns 回傳用於html img顯示url
	 */
	public base64ToUrl(base64: string): string{
		const buffer = this.fileServ.base64ToArraybuffer(base64);
		const fileLink = this.fileServ.getFileLink(buffer, "IMG");
		const url = <string>this.fileServ.linkToSelfUrl(fileLink);
		return url
	}


	/**
	 * 下載相關報告
	 * @param report_id 報告id
	 * @returns 回傳 ProductReport Model
	 */
	// public downloadReport(report_id: number){
	// 	let param = {
	// 		report_id: report_id
	// 	}
	// 	const conf = confirm("是否要下載？")
	// 	if (!conf) return 
	// 	this.spinnerState.dispatch(new OpenAction('Loading...'));
	// 	const $productList = this.productServ.fetchReport(param).pipe(
	// 		takeUntil(this.unsubscribe$),
	// 		catchError(err => {
	// 			this.spinnerState.dispatch(new CloseAction());
	// 			this.errServ.httpErrorHandle(err);
	// 			return of()
	// 		}),
	// 		map(res => res.Data),
	// 		tap((data: ProductModels.ProductReport) => {
	// 			console.log(data);
	// 			const buffer = this.fileServ.base64ToArraybuffer(<string>data.file)
	// 			const getFileLink = this.fileServ.getFileLink(buffer, "PDF")
	// 			this.fileServ.downloadLink(getFileLink, data.file_name)
	// 			this.spinnerState.dispatch(new CloseAction());

	// 		})
	// 	).subscribe()
	// }


	/**
	 * 下載靜態檔案
	 * @param fileName `string`: 檔案名稱
	 */
	public downloadStaticFile(fileName: string) {
		const flag = confirm(this.translate.instant('MESSAGE.DOWNLOAD'));
		if (!flag) return
		const fileUrl = `assets/files/${fileName}`;
		this.http.get(fileUrl, { responseType: 'blob' }).pipe(
			takeUntil(this.unsubscribe$),
			catchError(err => {
				this.errServ.httpErrorHandle(err);
				return of()
			}),
			tap((blob: Blob) => {
				const objUrl = URL.createObjectURL(blob);
				this.fileServ.downloadLink(objUrl, fileName);
			})
		).subscribe()
	}

}
